import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import { Divider, Drawer, IconButton, List, Stack } from '@mui/material';
import { useTopNavRouteData } from 'components/appRoute/hooks/useTopNavRouteData.js';
import UserNavigation from 'components/lorriniCompnents/navigation/userNavigation/UserNavigation';
import LastaDialog from 'components/UI/dialogs/Dialog';
import PropTypes from 'prop-types';
import { createElement, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getInfoByDomain } from 'utils/domainUtils';
import DrawerListItem from './DrawerListItem/DrawerListItem';
import { LeftSection, LogoIconWrapper, LogoTextWrapper, NavigationRoot, StyledDrawerPaper, StyledNavMiddleAdornment } from './NavigationDrawerStyled';

function NavigationDrawer({ user, features }) {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [helpDialogOpen, setHelpDialogOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDrawerOpenHandler = () => setDrawerOpen((state) => !state);

    const { topNavMiddleAdornment, helpDialogComponent, pageTitle, hideTopNav = false } = useTopNavRouteData();

    const handleTriggerHelpDialog = (isOpen) => {
        if (helpDialogComponent) {
            setHelpDialogOpen(isOpen);
        }
    };

    const helpDialogTitle = useMemo(() => (pageTitle ? `${pageTitle}` : 'Help Section'), [pageTitle]);
    const { logo, text } = getInfoByDomain();

    return (
        <NavigationRoot className="top-nav">
            <LeftSection className="left-section">
                <IconButton onClick={toggleDrawerOpenHandler}>
                    <MenuIcon sx={{ color: 'white' }} />
                </IconButton>
                <Stack direction="row" alignItems="center" sx={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
                    <LogoIconWrapper>{createElement(logo)}</LogoIconWrapper>
                    <LogoTextWrapper>{text}</LogoTextWrapper>
                </Stack>
            </LeftSection>

            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawerOpenHandler}
                PaperProps={{
                    component: StyledDrawerPaper,
                }}
            >
                <List>
                    <DrawerListItem user={user} features={features} toggleDrawer={toggleDrawerOpenHandler} />
                    <Divider />
                </List>
            </Drawer>

            <StyledNavMiddleAdornment hideTopNav={hideTopNav} className="topNavMiddleAdornment">
                {topNavMiddleAdornment}
            </StyledNavMiddleAdornment>

            <div className="user-navigation">
                <UserNavigation user={user} onClickHelp={() => handleTriggerHelpDialog(true)} />
            </div>

            <LastaDialog
                icon={<HelpOutlinedIcon sx={{ fill: 'var(--color-white)', width: '2rem', height: '2rem' }} />}
                title={helpDialogTitle}
                sxTitleText={{ color: 'var(--color-white)', fontSize: '1rem', fontWeight: 700 }}
                sxTitle={{ backgroundColor: 'var(--color-blue)' }}
                sxCloseButton={{ color: 'var(--color-white)' }}
                sxContent={{ padding: '0rem', overflowY: 'hidden' }}
                open={helpDialogOpen}
                onClose={() => handleTriggerHelpDialog(false)}
            >
                {helpDialogComponent}
            </LastaDialog>
        </NavigationRoot>
    );
}

NavigationDrawer.propTypes = {
    user: PropTypes.object,
    features: PropTypes.array,
};

export default NavigationDrawer;
